import React from 'react';

const Placeholder = (props: Record<string, unknown>): JSX.Element => {
  const { size = 20, ...rest } = props;
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={`${size}px`}
      height={`${size}px`}
      style={rest}
    >
      <path
        d="M24 12c0 6.65-5.35 12-12 12S0 18.65 0 12 5.35 0 12 0s12 5.35 12 12ZM11.902 6h-.937a.382.382 0 0 0-.36.383v2.775a.383.383 0 0 0 .382.382H12A2.475 2.475 0 0 1 14.46 12v5.25a.142.142 0 0 0 .144.149.144.144 0 0 0 .073-.021A6 6 0 0 0 18 11.94 6.06 6.06 0 0 0 11.902 6Zm1.095 8.46H12A2.46 2.46 0 0 1 9.54 12V6.368A.375.375 0 0 0 9.157 6H6.382A.382.382 0 0 0 6 6.383V12a6 6 0 0 0 6 6h1.035a.383.383 0 0 0 .367-.383v-2.775a.383.383 0 0 0-.382-.382h-.023Z"
        fill="#D1D8DF"
      />
    </svg>
  );
};

export default Placeholder;
